module.exports = __webpack_public_path__ + "static/img/1.b4eb644.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/sp/1.png
// module id = m/PQ
// module chunks = 0